// jQuery wrapper
(function($) {

    /**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');

		// Header bar scrolled
		scrollbarState();


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - (headerHeight + 20);
			// var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});



		/*****
		 * Menus
		 *****/
		// Hamburger & Mobile Menu
		$('.hamburger').click(function() {
			var target = $(this).data('target');

			$(this).toggleClass('is-active');
			$('body').toggleClass('mobile-menu-open');
		});

		// Desktop Menu
		$('#desktop-menu .hasChild > a').on('click', function() {
			event.preventDefault();
			var target = $(this).attr('href');

			// If menu currently open
			if ( $('#desktop-submenu').hasClass('open')) {
				// If target currently active 
				if ( $(target).hasClass('current') ) {
					$(this).removeClass('active');
					$('body').removeClass('menu-open');
					$('#desktop-submenu').removeClass('open');
					$('.sub-menu').removeClass('current');

				// If target not active
				} else {
					$('#desktop-menu a').removeClass('active');
					$('.sub-menu').removeClass('current');
					$(this).addClass('active');
					$(target).addClass('current');
				}

			// If menu not open
			} else {
				$('body').addClass('menu-open');
				$('#desktop-submenu').addClass('open');
				$(this).addClass('active');
				$(target).addClass('current');
			}			
		});


		// Accordion list (FAQs, Videos)
		if ($('.accordion-list').length > 0) {
			$('.accordion-list .answer:not(.active)').hide();

	        var allPanels = $('.accordion-list .answer');

	        $('.accordion-list .accordion-toggle').click( function() {
	        	var targetParent = $(this).data('parent');
	            var target = $(this).data('target');

	            // console.log(targetParent);

	            if ( $(target).hasClass('active') ) {
	                $(this).removeClass('current');
	                $(target).removeClass('active').slideUp(250);

	            	// Videos - Empty all players in parent accordion on close
        			$(targetParent + ' .video-wrapper').empty();

	            } else {
	                $('.accordion-list .accordion-toggle').removeClass('current');
	                $(targetParent + ' .answer').removeClass('active').slideUp(250);
	                $(this).addClass('current');
	                $(target).addClass('active').slideDown(250);
	                
	            	// Videos - Empty all players NOT in target
        			$('.answer:not(' + (target) + ') .video-wrapper').empty();
	            }
	            
	            // Prevent default 'link' behaviour
	            return false;
	        });
	    }


		// Select2 - Custom Dropdowns
		// News filter - Select2
		if ( $('.news-filter').length > 0 ) {
			$('#cat').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Category',
				//dropdownCssClass: 'filter_dropdown',
			});
		
			$('#archives-dropdown-2').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Select a month',
				//dropdownCssClass: 'filter_dropdown',
			});
		}
		// Form dropdowns
		if ( $('.form-wrap .gfield--input-type-select').length > 0) {
			$('.gfield--input-type-select select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				// placeholder: 'Category',
				//dropdownCssClass: 'filter_dropdown',
			});
		}

		// Teams List
		if ( $('#teams-filter').length > 0 ) {
			// Toggle (mobile)
			$('#teams-sidebar .toggle-mob button').click( function() {
				$('#teams-sidebar .toggle-mob').toggleClass('active');
				$('#teams-filter-mob').toggleClass('show');
			});

			// Toggle (desktop)
			$('#teams-sidebar .toggle-dt button').click( function() {
				$('#teams-sidebar .toggle-dt').toggleClass('active');
				$('#teams-filter').toggleClass('show');
			});

			// Show / hide teams		
			$('#teams-sidebar .team-filter button').click( function() {
				var target = $(this).data('target');

				$('#teams-sidebar .team-filter button').removeClass('current');
				$('.team-block').removeClass('active');

				$('.team-block .section-control').removeClass('active');
				$(target + ' .section-control').addClass('active');
				
				$(this).addClass('current');
				$(target).addClass('active')
			});
		}

		// Section Toggle
		if ( $('.section-control').length > 0 ) {
			$('.section-control').click( function() {
				var target = $(this).data('target');

				if ( $(this).hasClass('active')) {
					$(this).removeClass('active');
					$(target).removeClass('active');
				} else {
					$('.section-control').removeClass('active');
					$('.controlled-section').removeClass('active');

					$(this).addClass('active');
					$(target).addClass('active');
				}
			})
		}


		/*****
		* Carousels
		*****/
		// Pillar Carousel
		if ( $('.pillar-carousel').length > 0 ) {
			$('.pillar-carousel').flickity({
				// options
				autoPlay: 4000,
				pauseAutoPlayOnHover: false,
				cellAlign: 'left',
				contain: true,
				adaptiveHeight: false,
				freeScroll: false,
				pageDots: true,
				prevNextButtons: false,
				wrapAround: true
			});
		}

		// Services Carousel
		if ( $('.service-carousel').length > 0 ) {
			$('.service-carousel').flickity({
				// options
				autoPlay: 4000,
				pauseAutoPlayOnHover: false,
				cellAlign: 'left',
				contain: true,
				adaptiveHeight: false,
				freeScroll: true,
				pageDots: true,
				prevNextButtons: false
			});
		}

		// Partner Carousel
		if ( $('.partner-carousel').length > 0 ) {
			$('.partner-carousel').flickity({
				// options
				cellAlign: 'left',
				contain: true,
				adaptiveHeight: false,
				freeScroll: true,
				pageDots: false,
				prevNextButtons: false
			});
		}

		// Footer logo carousel
		if ( $('.footer-carousel').length > 0 ) {
			$('.footer-carousel').flickity({
				// options
				autoPlay: 6000,
				cellAlign: 'left',
				contain: true,
				adaptiveHeight: false,
				freeScroll: false,
				pageDots: false,
				prevNextButtons: false,
				wrapAround: true
			});
		}


	}); // End Document Ready


    // On load
	$(window).on('load', function() {

		submenuPadding();

    });


    // On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {

		submenuPadding();

	});


	/***
	** Functions
	***/

	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
    	var navHeight = $('#site-header').outerHeight();

    	// Position of div which trigger header change
    	var scrollChangePoint = $('.scroll-change-point').offset().top;

		if ( $(document).scrollTop() > scrollChangePoint ) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
    		$('body').removeClass('scrolled');
    		$('#site-header').removeClass('is-scrolled');
		}
	}

	// Desktop submenu padding 
	function submenuPadding() {
		// Menu height
		var menuHeight = $('#menu-desktop-menu').outerHeight();
		$('#desktop-submenu .nav').css('padding-top', menuHeight);
	}


// end jQuery wrapper
})(jQuery);